import { render, staticRenderFns } from "./govdisco.vue?vue&type=template&id=31c9281a"
import script from "./govdisco.vue?vue&type=script&lang=js"
export * from "./govdisco.vue?vue&type=script&lang=js"
import style0 from "./govdisco.vue?vue&type=style&index=0&id=31c9281a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports